module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PUU8eB/tc-custom/9781504090001.jpg?1707968122736",
      "alt": "This image is the cover for the book Treachery of Friends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treachery of Friends\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the Dagger Award–winning “top notch thriller writer,” a new novel of politics, religion, power, and a woman’s search for her missing father’s secrets (Simon Kernick, bestselling author of "), _c('i', [_vm._v("Relentless")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v(" A man lies bleeding on the roadside. Hidden in his clothing is a message to Sidney from her father—who has been missing for fourteen years . . ."), _c('br'), _c('br'), _vm._v(" Practical and level-headed Sid doesn’t believe in miracles. So she sets out on a search for her father that leads to his old friends from university—or at least, the two of them who are still around. One is the head of a religious cult. The other is an ambitious politician. And both have secrets they want to stay buried—secrets Sid will have to uncover before a killer strikes again . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Praise for CJ Carver")]), _c('br'), _c('br'), _vm._v(" “A page-turning must read.” —"), _c('i', [_vm._v("Booklist")]), _c('br'), _c('br'), _vm._v(" “Solid gold.” —Lee Child, #1 "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of the Jack Reacher series"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Exceptional.” —"), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(" (starred review)\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      CJ Carver\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0